// @flow

export const DAYS_IN_WEEK = 7;
export const SHIFTS_PER_DAY = 3;
export const SHIFTS_IN_WEEK = DAYS_IN_WEEK * SHIFTS_PER_DAY;
export const USER_DOCUMENTATION_PATH = "/docs";
export const DAY_NAMES = ["Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday", "Sunday"];

export const ROLE_ADMIN = "Admin";
export const ROLE_POWER_USER = "PowerUser";
export const ROLE_DEMO_USER = "DemoUser";
export const ROLE_TICKET_ADMIN = "TicketAdmin";
export const ROLE_TICKET_USER = "TicketUser";
export const ROLE_MAN_ELECTRICITY_ADMIN = "ElectricityAdmin";
export const ROLE_MAN_ELECTRICITY_USER = "ElectricityUser";
export const ROLE_MAN_PLANNER = "ManPlanner";
export const ROLE_MAN_SUPERVISOR = "ManSupervisor";
export const ROLE_MAN_SHIFTBOARD_MANAGER = "ManShiftboardManager";
export const ROLE_MAN_SHOPFLOOR_MANAGER = "ManShopfloorManager";
export const ROLE_MAN_TOOL_MANAGER = "ManToolManager";
export const ROLE_MAN_PG_VIEWER = "ManProductionGuidingViewer";
export const ROLE_MAN_DT_VIEWER = "ManDigitalTwinViewer";
